'use client';

import { AdminToolbar } from '@/components/AdminToolbar/AdminToolbar';
import type { ReactNode } from 'react';

type Props = {
    readonly children: ReactNode;
    readonly isAuthenticated: boolean;
};

/**
 * Client-side layout wrapper for full-page layouts.
 * Global modals mount once in `layout.tsx` (sibling to this wrapper).
 * reCAPTCHA mounts only under `login/layout` and `reset-password/layout`
 * so other full-page routes are not covered by the badge iframe.
 *
 * AdminToolbar only renders for authenticated sessions — unauthenticated
 * routes (login, reset-password) never show the admin bar even if a
 * stale ATG-admin JWT cookie is present.
 */
export const FullPageLayoutClient = ({ children, isAuthenticated }: Props) => (
    <div className="flex h-screen w-full flex-col bg-background-primary">
        {isAuthenticated && <AdminToolbar />}
        <div className="flex flex-1 flex-col overflow-hidden">{children}</div>
    </div>
);

FullPageLayoutClient.displayName = 'FullPageLayoutClient';
